/**
 * Breadcrumb route configuration.
 *
 * Each entry maps a URL pattern to an array of breadcrumb crumbs.
 * - `label` is an i18n key passed through t()
 * - `path` (optional) makes the crumb a link; may contain :param placeholders
 * - `param` (optional) names the route parameter whose dynamic label should replace the static label
 *
 * Patterns are matched most-specific-first (longest pattern wins).
 */
export const breadcrumbRoutes = [
  // ── User Company Routes (/mycompany/:companyid/...) ──

  { pattern: '/mycompany/:companyid/product/create', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Products', path: '/mycompany/:companyid/products' },
    { label: 'Create Product' },
  ]},
  { pattern: '/mycompany/:companyid/product/:productid', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Products', path: '/mycompany/:companyid/products' },
    { label: 'Edit Product', param: ':productid' },
  ]},
  { pattern: '/mycompany/:companyid/products', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Products' },
  ]},

  { pattern: '/mycompany/:companyid/news/create', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'News', path: '/mycompany/:companyid/news' },
    { label: 'Create News' },
  ]},
  { pattern: '/mycompany/:companyid/news/:newsid', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'News', path: '/mycompany/:companyid/news' },
    { label: 'Edit News', param: ':newsid' },
  ]},
  { pattern: '/mycompany/:companyid/news', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'News' },
  ]},

  { pattern: '/mycompany/:companyid/job-listing/create', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Job Listings', path: '/mycompany/:companyid/recruiting-lectures' },
    { label: 'Create Job Listing' },
  ]},
  { pattern: '/mycompany/:companyid/job-listing/:newsid', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Job Listings', path: '/mycompany/:companyid/recruiting-lectures' },
    { label: 'Edit Job Listing', param: ':newsid' },
  ]},

  { pattern: '/mycompany/:companyid/register-action/:actionid', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Promotions', path: '/mycompany/:companyid/actions' },
    { label: 'Edit Promotion', param: ':actionid' },
  ]},
  { pattern: '/mycompany/:companyid/register-action', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Promotions', path: '/mycompany/:companyid/actions' },
    { label: 'Register Promotion' },
  ]},
  { pattern: '/mycompany/:companyid/actions', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Promotions' },
  ]},

  { pattern: '/mycompany/:companyid/register-recruiting-lecture/:lectureid', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Recruiting', path: '/mycompany/:companyid/recruiting-lectures' },
    { label: 'Edit Recruiting Lecture', param: ':lectureid' },
  ]},
  { pattern: '/mycompany/:companyid/register-recruiting-lecture', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Recruiting', path: '/mycompany/:companyid/recruiting-lectures' },
    { label: 'Register Recruiting Lecture' },
  ]},
  { pattern: '/mycompany/:companyid/recruiting-lectures', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Recruiting' },
  ]},

  { pattern: '/mycompany/:companyid/register-lecture-mui', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Lectures', path: '/mycompany/:companyid/lectures' },
    { label: 'Register Lecture' },
  ]},
  { pattern: '/mycompany/:companyid/lectures', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Lectures' },
  ]},

  { pattern: '/mycompany/:companyid/myemployeeprofile/:employeeid', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Employees', path: '/mycompany/:companyid/employees' },
    { label: 'Employee Profile', param: ':employeeid' },
  ]},
  { pattern: '/mycompany/:companyid/employees', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Employees' },
  ]},

  { pattern: '/mycompany/:companyid/departments', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Departments' },
  ]},

  { pattern: '/mycompany/:companyid/profile', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Company Profile' },
  ]},

  { pattern: '/mycompany/:companyid/billing', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Billing Settings' },
  ]},

  { pattern: '/mycompany/:companyid/requests', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Requests' },
  ]},

  { pattern: '/mycompany/:companyid/company-bookings', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Bookings' },
  ]},

  { pattern: '/mycompany/:companyid/event-guests', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Event Guests' },
  ]},

  { pattern: '/mycompany/:companyid/edit-booth/:boothId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Edit Booth', param: ':boothId' },
  ]},

  { pattern: '/mycompany/:companyid/select-booth/:eventId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Select Booth' },
  ]},
  { pattern: '/mycompany/:companyid/select-booth-map/:eventId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid', path: '/mycompany/:companyid' },
    { label: 'Select Booth' },
  ]},

  // Company index route
  { pattern: '/mycompany/:companyid', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Company', param: ':companyid' },
  ]},

  // ── Admin Routes (/admin/...) ──

  { pattern: '/admin/user/:userid', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Users', path: '/admin/users' },
    { label: 'Edit User', param: ':userid' },
  ]},
  { pattern: '/admin/users', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Users' },
  ]},
  { pattern: '/admin/cognito-users', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Cognito Users' },
  ]},
  { pattern: '/admin/create-user', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Users', path: '/admin/users' },
    { label: 'Create User' },
  ]},

  { pattern: '/admin/company/:companyid', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Companies', path: '/admin/companies' },
    { label: 'Edit Company', param: ':companyid' },
  ]},
  { pattern: '/admin/companies', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Companies' },
  ]},
  { pattern: '/admin/create-company', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Companies', path: '/admin/companies' },
    { label: 'Create Company' },
  ]},

  { pattern: '/admin/lecture/:companyid/:lectureid', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Lectures', path: '/admin/lectures' },
    { label: 'Edit Lecture', param: ':lectureid' },
  ]},
  { pattern: '/admin/lectures', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Lectures' },
  ]},
  { pattern: '/admin/lecture_scheduling', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Lecture Scheduling' },
  ]},

  { pattern: '/admin/product/create', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Products', path: '/admin/products' },
    { label: 'Create Product' },
  ]},
  { pattern: '/admin/product/:productId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Products', path: '/admin/products' },
    { label: 'Edit Product', param: ':productId' },
  ]},
  { pattern: '/admin/products', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Products' },
  ]},
  { pattern: '/admin/stockreservations', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Stock Reservations' },
  ]},
  { pattern: '/admin/booths', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Booths' },
  ]},
  { pattern: '/admin/booth/create', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Booths', path: '/admin/booths' },
    { label: 'Create Booth' },
  ]},
  { pattern: '/admin/booth/:productId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Booths', path: '/admin/booths' },
    { label: 'Edit Booth', param: ':productId' },
  ]},

  { pattern: '/admin/company-product/:companyId/product/:productId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Company Products', path: '/admin/company-products' },
    { label: 'Edit Product', param: ':productId' },
  ]},
  { pattern: '/admin/company-products', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Company Products' },
  ]},

  { pattern: '/admin/company-job/:jobId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Company Jobs', path: '/admin/company-jobs' },
    { label: 'Edit Job', param: ':jobId' },
  ]},
  { pattern: '/admin/company-jobs', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Company Jobs' },
  ]},

  { pattern: '/admin/news/:companyId/:newsId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'News', path: '/admin/news' },
    { label: 'Edit News', param: ':newsId' },
  ]},
  { pattern: '/admin/news/create', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'News', path: '/admin/news' },
    { label: 'Create News' },
  ]},
  { pattern: '/admin/news', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'News' },
  ]},

  { pattern: '/admin/order/create', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Orders', path: '/admin/orders' },
    { label: 'Create Order' },
  ]},
  { pattern: '/admin/orders', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Orders' },
  ]},

  { pattern: '/admin/tickets', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Tickets' },
  ]},

  { pattern: '/admin/discount/:discountId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Discounts', path: '/admin/discounts' },
    { label: 'Edit Discount', param: ':discountId' },
  ]},
  { pattern: '/admin/discounts', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Discounts' },
  ]},

  { pattern: '/admin/event/create', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Events', path: '/admin/events' },
    { label: 'Create Event' },
  ]},
  { pattern: '/admin/event/invitation-codes', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Events', path: '/admin/events' },
    { label: 'Invitation Codes' },
  ]},
  { pattern: '/admin/event/:eventId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Events', path: '/admin/events' },
    { label: 'Edit Event', param: ':eventId' },
  ]},
  { pattern: '/admin/events', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Events' },
  ]},
  { pattern: '/admin/event-carpets', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Event Carpets' },
  ]},
  { pattern: '/admin/booked-booths', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Booked Booths' },
  ]},
  { pattern: '/admin/custom-booth-requests', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Custom Booth Requests' },
  ]},
  { pattern: '/admin/booked-equipment', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Booked Equipment' },
  ]},
  { pattern: '/admin/printticket', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Print Ticket' },
  ]},
  { pattern: '/admin/promotiontimes', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Promotion Times' },
  ]},
  { pattern: '/admin/video-progress', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Video Progress' },
  ]},

  // Admin Insight
  { pattern: '/admin/insight/course/create', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Courses', path: '/admin/insight/courses' },
    { label: 'Create Course' },
  ]},
  { pattern: '/admin/insight/course/:courseId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Courses', path: '/admin/insight/courses' },
    { label: 'Edit Course', param: ':courseId' },
  ]},
  { pattern: '/admin/insight/courses', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Courses' },
  ]},
  { pattern: '/admin/insight/user-course-progress/:userId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'User Course Progress', param: ':userId' },
  ]},

  // Admin Academy
  { pattern: '/admin/academy/seminar/create', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Seminars', path: '/admin/academy/seminars' },
    { label: 'Create Seminar' },
  ]},
  { pattern: '/admin/academy/seminar/:seminarId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Seminars', path: '/admin/academy/seminars' },
    { label: 'Edit Seminar', param: ':seminarId' },
  ]},
  { pattern: '/admin/academy/seminars', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Seminars' },
  ]},

  // Admin Industries
  { pattern: '/admin/industry/create', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Industries', path: '/admin/industries' },
    { label: 'Create Industry' },
  ]},
  { pattern: '/admin/industry/:industryId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Industries', path: '/admin/industries' },
    { label: 'Edit Industry', param: ':industryId' },
  ]},
  { pattern: '/admin/industries', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Industries' },
  ]},

  // Admin Mediathek (media library)
  { pattern: '/admin/mediathek/series/:seriesId/items/create', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Media library', path: '/admin/mediathek' },
    { label: 'Series', param: ':seriesId', path: '/admin/mediathek/series/:seriesId' },
    { label: 'New item' },
  ]},
  { pattern: '/admin/mediathek/series/create', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Media library', path: '/admin/mediathek' },
    { label: 'New series' },
  ]},
  { pattern: '/admin/mediathek/series/:seriesId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Media library', path: '/admin/mediathek' },
    { label: 'Edit series', param: ':seriesId' },
  ]},
  { pattern: '/admin/mediathek/items/:itemId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Media library', path: '/admin/mediathek' },
    { label: 'Items', path: '/admin/mediathek/items' },
    { label: 'Edit item', param: ':itemId' },
  ]},
  { pattern: '/admin/mediathek/items', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Media library', path: '/admin/mediathek' },
    { label: 'Items' },
  ]},
  { pattern: '/admin/mediathek', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Media library' },
  ]},

  // ── Top-level Routes ──

  { pattern: '/myprofile', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Personal Profile' },
  ]},
  { pattern: '/companies', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Companies' },
  ]},
  { pattern: '/company/:companyid/request-affiliation', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Companies', path: '/companies' },
    { label: 'Request Affiliation', param: ':companyid' },
  ]},
  { pattern: '/company/:companyid', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Companies', path: '/companies' },
    { label: 'Company', param: ':companyid' },
  ]},
  { pattern: '/shop', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Shop' },
  ]},
  { pattern: '/event-lectures', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Event Lectures' },
  ]},
  { pattern: '/my-lectures', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'My Lectures' },
  ]},
  { pattern: '/chat', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Chat' },
  ]},
  { pattern: '/book-ticket', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Book Ticket' },
  ]},
  { pattern: '/bookings', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Bookings & Tickets' },
  ]},
  { pattern: '/checkout', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Checkout' },
  ]},
  { pattern: '/order/confirmation/:orderId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Order Confirmation' },
  ]},
  { pattern: '/onboarding', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Onboarding' },
  ]},
  { pattern: '/accountsetup', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Account Setup' },
  ]},

  // Lecture / Insight / Academy
  { pattern: '/lecture/:lectureId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Event Lectures', path: '/event-lectures' },
    { label: 'Lecture', param: ':lectureId' },
  ]},
  { pattern: '/insight/lecture-video/:lectureId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Insight Lectures', path: '/insight/lectureVideos' },
    { label: 'Lecture Video', param: ':lectureId' },
  ]},
  { pattern: '/insight/lectureVideos', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Insight Lectures' },
  ]},
  { pattern: '/academy/basics/lecture/:lectureId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Academy', path: '/academy/basics' },
    { label: 'Lecture', param: ':lectureId' },
  ]},
  { pattern: '/academy/basics/course/:courseId', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Academy', path: '/academy/basics' },
    { label: 'Course', param: ':courseId' },
  ]},
  { pattern: '/academy/basics', crumbs: [
    { label: 'Home', path: '/' },
    { label: 'Academy' },
  ]},
];
